import { useBreakpoint } from './useBreakpoint';
export const useMatchBreakpoint = (input = []) => {
    const breakpoint = useBreakpoint();
    const breakpoints = Array.isArray(input) ? input : [input];
    return breakpoints.includes(breakpoint);
};
//# sourceMappingURL=useMatchBreakpoint.js.map